import { Grid, styled } from '@mui/material';

import { Typography } from '../../atoms/Typography';

export const TitleLabel = styled(Typography)`
  font-size: 16px;
  font-weight: bold;
  color: #00343f;
`;

export const GridAlignContainer = styled(Grid)`
  display: flex;
  align-items: center;
  * {
    margin-right: 5px;
  }
`;

export const WebItemGrid = styled(Grid)`
  min-height: 35px;
  margin-bottom: 5px;
  align-items: center;
  border-bottom: 1px dashed lightgrey;
`;

export const MobileItemGrid = styled(Grid)`
  min-height: 35px;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px dashed lightgrey;
`;